import { z } from 'zod';
import { SipEngineBootstrapInputSchema } from '@sbclite/core/bootstrap';

export const engineDraftSchema = z.preprocess(value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  // Empty controls and JSON-encoded NaN are incomplete input, not defaults.
  return Object.fromEntries(Object.entries(value).filter(([, entry]) => entry !== '' && entry !== null));
}, z.object(SipEngineBootstrapInputSchema.shape).partial());

export function onboardingStorageKey(userId: string, workflow: string): string {
  return `sbclite.onboarding.v2:${window.location.origin}:${userId}:${workflow}`;
}

export function readOnboardingDraft<T>(key: string, schema: z.ZodType<T>): T | undefined {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return undefined;
    const parsed = schema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : undefined;
  } catch { return undefined; }
}

export function saveOnboardingDraft(key: string, value: unknown): boolean {
  try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
}

export function clearOnboardingDraft(key: string): void {
  try { sessionStorage.removeItem(key); } catch { /* In-memory reset still works. */ }
}
